import { z } from "zod";
import { merchantGroupSchema } from "@qivia/schemas-shared";

export const countryCodeSchema = z.enum([
  "FR",
  "BE",
  "LU",
  "DE",
  "ES",
  "IT",
  "PT",
  "AD",
  "MC",
  "NL",
  "AT",
]);

export const typeLimitSchema = z.enum(["DAILY", "WEEKLY", "MONTHLY"]);

export const ruleStatusSchema = z.enum(["ACTIVE", "DELETED"]);

export const categorySchema = z.enum([
  "TOLL",
  "FUEL_AUTOMATON",
  "SERVICE_STATION",
  "WASH",
  "PARKING",
  "ELECTRIC",
  "FREIGHT_FORWARDER_AND_CUSTOMS",
  "MAINTENANCE",
  "OTHER",
]);

export const allowedPeriodSchema = z.object({
  dayOfWeek: z.string(),
  startTime: z.string(),
  endTime: z.string(),
});

export const categoryItemSchema = z.object({
  category: categorySchema,
  amountLimit: z.int().nullable(),
  typeLimit: typeLimitSchema.nullable(),
});
//   .refine(
//     (data) =>
//       (data.amountLimit === null && data.typeLimit === null) ||
//       (data.amountLimit !== null && data.typeLimit !== null),
//     {
//       message:
//         "amountLimit and typeLimit must be both null or both set (DB constraint: amount_limit_and_type_limit_set_together)",
//       path: ["amountLimit"],
//     },
//   );
// INFO : For now we do not use the .refine() above in order to keep the current behavior and let the database handle the constraint.
// At some point it could be added back to the schema if we want to enforce the constraint at the API level.

export type CountryCode = z.infer<typeof countryCodeSchema>;
export type MerchantGroup = z.infer<typeof merchantGroupSchema>;
export type TypeLimit = z.infer<typeof typeLimitSchema>;
export type RuleStatus = z.infer<typeof ruleStatusSchema>;
export type Category = z.infer<typeof categorySchema>;
export type AllowedPeriod = z.infer<typeof allowedPeriodSchema>;
export type CategoryItem = z.infer<typeof categoryItemSchema>;

export const categories = categorySchema.options;
export const allowableCountries = countryCodeSchema.options;
